// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "物流中心运营管理",
      "tec": "王庆喜",
      "week": "1-8周",
      "add": "教学楼D座224经管"
    },
    [
      {
        "sub": "物流成本管理",
        "tec": "吕开颜",
        "week": "1-8周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "第三方物流案例分析",
        "tec": "孙宏英",
        "week": "9周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "集装箱与多式联运",
        "tec": "李化",
        "week": "10周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "物流包装实务",
        "tec": "贲立欣",
        "week": "11周",
        "add": "教学楼D座224经管"
      }
    ],
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "流通加工技术",
      "tec": "李化",
      "week": "1-11周",
      "add": "教学楼D座224经管"
    },
    {
      "sub": "物流管理前沿知识",
      "tec": "孙宏英",
      "week": "1-11周",
      "add": "教学楼D座224经管"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "物流包装实务",
      "tec": "贲立欣",
      "week": "1-11周",
      "add": "教学楼D座225经管"
    },
    {
      "sub": "技术经济学",
      "tec": "田凤权",
      "week": "1-11周",
      "add": "教学楼D座224经管"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "第三方物流案例分析",
      "tec": "孙宏英",
      "week": "1-11周",
      "add": "教学楼D座224经管"
    },
    {
      "sub": "物流成本管理",
      "tec": "吕开颜",
      "week": "1-8周",
      "add": "教学楼D座224经管"
    },
    0,
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "物流中心运营管理",
        "tec": "王庆喜",
        "week": "1-8周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "技术经济学",
        "tec": "田凤权",
        "week": "9周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "流通加工技术",
        "tec": "李化",
        "week": "10周",
        "add": "教学楼D座224经管"
      },
      {
        "sub": "物流管理前沿知识",
        "tec": "孙宏英",
        "week": "11周",
        "add": "教学楼D座224经管"
      }
    ],
    {
      "sub": "集装箱与多式联运",
      "tec": "李化",
      "week": "1-11周",
      "add": "教学楼D座225经管"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
